module.exports = {"520123001":"龙场街道","520123002":"阳明洞街道","520123003":"景阳街道","520123004":"扎佐街道","520123005":"久长街道","520123103":"六广镇","520123104":"六屯镇","520123105":"洒坪镇","520123106":"六桶镇","520123107":"谷堡镇","520123108":"小箐镇","520123204":"大石布依族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520123.json
// module id = 2587
// module chunks = 0